const appConfig = {
  apiUrlBase: 'https://vmi.dev.mccolls.net.au/api',
};

export default appConfig;
